export var SupportRequestStatus;
(function (SupportRequestStatus) {
    SupportRequestStatus["new"] = "new";
    SupportRequestStatus["pendingCustomer"] = "pendingCustomer";
    SupportRequestStatus["updatedByCustomer"] = "updatedByCustomer";
    SupportRequestStatus["inProgress"] = "inProgress";
    SupportRequestStatus["closed"] = "closed";
})(SupportRequestStatus || (SupportRequestStatus = {}));
